import { Injectable } from '@angular/core';
import { Environment } from '@rma/generic/util/environment';
import { algoliasearch } from 'algoliasearch';
import { catchError, EMPTY, from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlgoliaSearch {
  private searchClient: ReturnType<typeof algoliasearch>;
  private readonly indexName: string;

  public constructor(private readonly environment: Environment) {
    const { algoliaApplicationId, algoliaSearchApiKey, algoliaDashboardFeaturesIndexName } = this.environment;
    this.searchClient = algoliasearch(algoliaApplicationId, algoliaSearchApiKey);
    this.indexName = algoliaDashboardFeaturesIndexName;
  }

  public search<T>(value: string, options?: { filters: string }): Observable<Array<T>> {
    return from(
      this.searchClient.searchSingleIndex<T>({
        indexName: this.indexName,
        searchParams: {
          query: value,
          ...this.appendRegionFilter(options),
        },
      }),
    ).pipe(
      map((x) => x.hits),
      catchError(() => {
        console.error(`Algolia failed while searching ${value} with ${options}`);
        return EMPTY;
      }),
    );
  }

  private appendRegionFilter(options?: { filters: string }): { filters: string } {
    const { tenant } = this.environment;
    const regionFilter = tenant === 'nz' ? 'ShowNZ:TRUE' : tenant === 'au' ? 'ShowAU:TRUE' : 'ShowUS:TRUE';
    return options ? { filters: `${options.filters} AND ${regionFilter}` } : { filters: regionFilter };
  }
}
